import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { NotificationType } from '../types';
import { selectNotification } from '../../../../store/selectors';
import {
  setNotification,
  closeNotification as closeNotificationAction,
  clearNotificationMessage
} from '../../../../actions';

let startToShowNotif = 0;

export const useNotification = (currPage: string | null = null) => {
  const { message, isClosing, targetPage } = useSelector(selectNotification);
  const isTargetPage = !targetPage || currPage?.includes(targetPage);
  const dispatch = useDispatch();

  const setNotificationMessage = (
    text: string,
    type: NotificationType,
    page = null
  ) => {
    dispatch(setNotification({ message: { text, type }, targetPage: page }));
    startToShowNotif = 0;
  };

  const closeNotification = () => {
    dispatch(closeNotificationAction());
  };

  const clearNotification = () => {
    dispatch(clearNotificationMessage());
    startToShowNotif = 0;
  };

  useEffect(() => {
    if (message && !isClosing && isTargetPage) {
      const timer = setTimeout(closeNotification, 5000);
      return () => clearTimeout(timer);
    }

    if (isClosing) {
      const timer = setTimeout(clearNotification, 500);
      return () => clearTimeout(timer);
    }
  }, [message, isClosing, targetPage, currPage]);

  useEffect(() => {
    startToShowNotif += 1;
  }, [currPage]);

  return {
    message,
    setNotificationMessage,
    clearNotification,
    closeNotification,
    isClosing,
    isTargetPage,
    startToShowNotif
  };
};
